
import Vue from 'vue';
import Hero from '~/components/index/hero.vue'
import ChefHighlight from '~/components/index/chef-highlight.vue'
import {PageInterface} from "~/store/page"
import {marked} from 'marked'
import {AddressInterface} from "~/components/filter/address-search.vue";

export default Vue.extend({
  name: 'LocationPage',
  components: {Hero, ChefHighlight},
  head() {
    return {
      title: this.$data.seoTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$data.seoDescriptionMeta,
        }
      ],
    }
  },
  data(): { page: PageInterface | null, heroTitle: string, content: string, seoTitle: string, seoDescriptionMeta: string } {
    return {
      page: null,
      content: '',
      heroTitle: '',
      seoTitle: '',
      seoDescriptionMeta: '',
    }
  },
  computed: {
    markdown() {
      const renderer = {
        heading(text: string, level: number) {
          return `<h${level} class="text-primary">${text}</h${level}>`;
        },
        link(href: string, title: string, text: string) {
          let link = `<a href="${href}" class="text-primary hover:underline"`;
          if (title) {
            link += `title="${title}"`
          }

          link += `>${text}</a>`;

          return link
        }
      };

      marked.use({renderer});

      return marked.parse(this.$data.content);
    }
  },
  async fetch() {
    // Detect "catering" type from "/catering-amsterdam/"
    const path = this.$route.path.replaceAll('/', '');
    const location = this.$route.params.location;
    const type = path.replace('-' + location, '');
    const slug = `${type}-${location}`;

    // @ts-ignore
    this.page = await this.$axios.$get<{ data: PageInterface }>(`/v1/page/${slug}`).then(data => data.data);
    if (this.page) {
      this.$data.content = this.page.content

      const address = {
        title: this.page.title,
        fullTitle: this.page.title,
        country: 'Nederland',
        country_code: "NLD",
        city: this.page.title,
      } as AddressInterface

      this.$store.commit('filter/UPDATE_FILTERS', {
        address,
        // this does not work because searching is done by refresh. See CHEFSTBL-374
        // dynamicFilters: {
        //   listing_category: [2], // todo dynamic ID (as array or just int?)
        // },
      })

      let friendlyType = type.charAt(0).toUpperCase() + type.slice(1);
      friendlyType = friendlyType.replaceAll('-', ' ');

      this.heroTitle = `${friendlyType} in ${this.page.title}`

      this.$data.seoTitle = `${friendlyType} in ${this.page.title} en omgeving vind je hier - CHEFSTBL`;
      this.$data.seoDescriptionMeta = `${friendlyType} in ${this.page.title} boek je via CHEFSTBL! Bekijk hier het ruime aanbod van ${friendlyType} in ${location} en plan je ideale diner.`;
    }
  }
});
